export enum DecisionTypes {
  Rejection = 1,
  Pause = 2,
  InProcess = 3,
  Recognition = 4,
  Objection = 5,
  FurtherReference = 7,
}

export enum StatusTypes {
  REQUEST_EXAMINATION = 1,
  MEDICAL_OPINION = 2,
  WAITING_FOR_DECISION = 3,
  MEDICAL_COMMITTEE = 4,
  DISABILITY_RECOGNITION = 5,
}
